export default {
  mounting: {
    buttons: {
      save: 'Save',
      "edit":"edit",
      close: 'Close',
      'add-video': 'Add Video',
      'add-audio': 'Add Audio',
      cursor: 'Select',
      hand: 'Drag & drop',
      undo: 'Undo',
      redo: 'Redo',
      refresh: 'Refresh',
      cut: 'Cut',
      copy: 'Copy',
      paste: 'Paste',
      "duplicate": "Duplicate",
      delete: 'Delete',
      cancel: 'Cancel',
      mic: 'Mic',
      preview: 'Preview',
      zoomin: 'Zoom +',
      zoomout: 'Zoom -',
      'upload-img': 'Select photo',
      'add-annotation': 'Add',
      'edit-annotation': 'Edit',
      'delete-annotation': 'Delete',
      "add-text": "add text",
      "add-picture": "add picture",
      "add-pdf": "add pdf",
      "ok": "OK",
      "start":"Start montage",
      "end":"End montage",
    },
    shortkeys: {
      save: '(Ctrl + S)',
      undo: '(Ctrl + Z)',
      redo: '(Ctrl + Shift + Z)',
      cut: '(Ctrl + X)',
      "duplicate": "(Ctrl + D)",
      copy: '(Ctrl + C)',
      paste: '(Ctrl + V)',
      delete: '(Del)',
      zoomin: '(Ctrl + +)',
      zoomout: '(Ctrl + -)',
    },
    tabs: {
      video: 'Video',
      audio: 'Audio',
      image: 'Image',
      recording: 'Recording...',
    },
    inputs: {
      'scene-name': 'Scene name',
      search: 'Search video by title',
    },
    "titles": {
      "title": "Title",
      "video": "Video",
      "audio": "Audio",
      "text": "Text",
      "image": "Image",
      "color": "Color",
      "backcolor": "Background Color",
      "font-size": "Font size",
      "font-family": "Font family",
      "style": "Style",
      "go": "Go to:",
      "model-image" : "Add image & logo",
      "yoursearch":"Your search for",
      "noresult":"found no results",

      "transitionLeft":"Left transition",
      "transitionRight":"Right transition",
      "transitionTop":"Top transition",
      "transitionBottom":"Bottom transition",
      "noTransition":"No transition",
      "Transitionzoom":"Zoom transition",
      "typeshow": {
        "list": "List",
        "thumbnails": "Thumbnails"
      },
      "table":
        { "thumbnail": "Thumbnail",
          "title": "Title",
          "duration": "Duration"
        }
    },
    "effects": {
      "drag": "Put the video here"
    },
    messages: {
      'confirm-delete': 'Are you sure to delete this video ?',
      'empty-cut': 'Nothing to cut',
      'montage-cut': 'Cutted (montage area)',
      'montage-copy': 'Copied (montage area)',
      'player-copy': 'Copied (player), duration: ',
      'empty-insert': 'Nothing to insert',
      'player-insert': 'Inserted, duration: ',
      'success-delete': 'Videos are deleted from the montage area',
      'save-montage-empty': 'There is no video in the montage area !',
      'save-title-empty': 'Please set the video title',
      'save-success': 'Video saved',
      'success-add-video': 'Video added',
      'success-add-image': 'Image added',
      "failed-add-image": "Image not valid",
      'success-add-audio': 'Audio added',
      'text-style-title': 'Text style',
      'transition-style-title': 'Transition',
      'choose-another-color': 'Choose another color',
      'empty-annotation-text': 'Nothing to insert',
      'drop-image': 'Drop the image here',
      "superposition": "Superposition",
      "full-screen": "Full screen "
    },
  },
  subtitle: {
    buttons: {
      add: 'Add / Edit subtitle',
      delete: 'Delete this subtitle',
      save: 'Save',
      cancel: 'Cancel',
      'select-file': 'Choose file',
      'open-upload-subtitles': 'Submit a subtitlesl file',
      'export-subtitles': 'Export file of subtitles',
      'transcription-subtitles': 'Automatic transcription',
      'transcription-review-subtitles': 'Automatic transcription and review',
      'option-export-import': 'Export / import a file',
      'download-prototype': 'Go down',
    },
    inputs: {
      'subtitle-content': 'Subtitle',
    },
    titles: {
      start: 'Start',
      end: 'End',
    },
    messages: {
      "error-add-subtitle-vide": "The subtitle is empty",
      'confirm-delete': 'Are you sure to delete this subtitle ?',
      'list-transcription': 'Sélectionnez le type de transcription que vous souhaitez le faire ',
      'title-confirm-delete': 'Delete all',
      'confirm-delete-subtitles': 'Are you sure to delete all the subtitles ?',
      'error-add-subtitle': 'Subtitle overlay error',
      'success-add-subtitle': 'Subtitle added',
      'confirm-save': 'Are you sure to save subtitles ?',
      'success-save': 'Successfully saved',
      'empty-save': 'Nothing to save',
      'drag-subtitles': 'Drop file anywhere to upload subtitles',
      'error-uploded-file-type': 'Choose a valid file type (txt, srt, vtt)',
      'error-validate-file-type': 'File is not valid',
      'upload-modal-title': 'Upload subtitle file',
      'upload-modal-message-1':
        'You can drop your subtitles file here to upload. Attention, only  *.srt *.vtt *.txt files are allowed and the text format (UTF-8 et AINSI) are accepted.',
      'upload-modal-message-2': 'The formats of the different types of subtitles:',
      'subtitles-exported': 'Subtitles file exported',
      'no-subtitles-to-export': 'No subtitles to export',
      'change-lang': 'Language changed to ',
      'file-format-title': 'Preview file',
      'msg-error-input': 'Error! Verify your input...',
      'txt-format':
        ';;00:00:00;;00:00:03;;This is the first title;;00:00:03;;00:00:05;;This is the second title',
      'srt-format': `
      1
      00:00:00,000 --> 00:00:03,000
      This is the first title
      
      2
      00:00:03,000 --> 00:00:05,000
      This is the second title`,
      'vtt-format': `
      WEBVTT

      1
      00:00:00.000 --> 00:00:03.000
      This is the first title
      
      2
      00:00:03.000 --> 00:00:05.000
      This is the second title`,
      fr: 'French',
      en: 'English',
      es: 'Spanish',
      it: 'Italian',
    },
  },
  editor: {
    buttons: {
      add: 'Add',
      delete: 'Delete',
      save: 'Save',
      modify: 'Modify',
      slide: 'Slide',
      continue: 'Continue',
      cancel: 'Cancel',
      'save-modification': 'Save modification',
      'download-prototype': 'Download',
      confirm: 'Confirm',
    },
    title: {
      chapter: 'Chapter',
      question: 'Question',
      quiz: 'Quiz',
      'hidden-area': 'Hidden Area',
      sondage: 'Survey',
      password: 'Authentication',
      thumb: 'Thumbnail',
      video: 'Video',
      'index-list': 'List',
      save: 'Save',
      cta: 'Call to action',
      slide: 'Slides',
      interactivity: 'Interactivity',
      annotations: 'Annotations',
      preview: 'Preview',
      navigation: 'Navigation',
      interactivity_with_timeline: 'Interactivity with timeline',
      interactivity_without_timeline: 'Interactivity without timeline',
    },
    placeholder: {
      'add-chapter': 'Add a chapter',
      'add-question': 'Add a question',
      insert_question: 'Your question',
      insert_message: 'Your message',
      'yes-no': 'YES / NO',
      'yes-no-nsp': 'YES / NO / DNK',
      simple: 'Simple choice',
      multiple: 'Multiple choice',
      'add-response': 'Add a response',
      title: 'Title',
      'success-upload': 'Your file is uploaded successfully!',
      'open-upload-media': 'Submit a file',
      or: 'or',
      'select-file': 'Select a file',
      'generate-thumb': 'Generate a thumbnail',
      loop: 'Play in loop',
      response: 'Response',
      AddResponse: 'Add response',
      responseButton: 'Add a response',
      choice: 'Choice',
      choiceButton: 'Add a choice',
      instant: 'Display instant: ',
      duration: 'Display duration: ',
      href: 'URL',
      password: 'You must insert the password to watch the video.',
      text: 'Text',
      image: 'Image',
      pdf: 'PDF',
    },
    error: {
      error: 'Error',
      'chapter-empty': 'Write a chapter!',
      'error-message-time':
        'Error! There is a content in this instant. Would you like to delete the previous content and continue?',
      'error-message-time-overflow': 'Error! You have to exceed the video duration',
      'msg-error-input': 'Error! Verify your input...',
      'msg-error-slide-extension':
        'Error! Only this extensions are acceptable (.jpeg), (.jpe), (.jpg), (.gif), (.png) et (.webp)',
      'msg-error-video-extension': 'Error! Only this extension is acceptable .mp4',
      'error-xhr':
        'An error have occured. Please try again later. If the problem stil exist, please contact your technical manager. Thank you.',
      'error-flux': 'Video stream not found',
      'error-flux-try-again': 'Video stream error, click to try again',
      'error-duration-null': 'Duration must not be null',
      'msg-error-cta-img-extension':
        "<h5 class='alert-heading'>Error!</h5> Only those extensions are allowed (.jpeg), (.jpe), (.jpg), (.gif), (.png) et (.webp)",
      'msg-error-cta-pdf-extension':
        "<h5 class='alert-heading'>Error!</h5> Only PDF files are allowed",

      'api-error-title': 'Admin: Api problem',
      'api-error-msg': 'IP does not belong to any zone',
      'no-result-msg': 'The box is not accessible',
      'no-result-video': "The video being processed",
      'no-result': 'No result found',
      'api-zonning': 'connection to api zoning failed',
      'error-code': 'error code',
      'video-not-found': 'Video not found',
      'video-not-access': 'Access denied',
      email: 'Your email',
      claim: 'Your claim',
      submit: 'Submit',
    },
    confirm: {
      delete: 'Would you like to delete this item?',
    },
  },
  worksapce: {
    buttons: {
      'add-comment': 'Comment',
      'edit-comment': 'Edit',
      'hide-comment': 'Hide',
      'info-comment': 'Info',
      'delete-comment': 'Delete comment',
      'cancel-edit-comment': 'Cancel',
      'reply-comment': 'Reply',
      'sort-asc': 'Ascending order (most recent)',
      'sort-desc': 'Descending order (oldest)',
      'show-more': 'Show more',
      'show-less': 'Show less',
      'confirm-delete': 'Confirm',
      'cancel-delete': 'Cancel',
      'add-reply': 'Reply',

    },
    placeholder: {
      'write-something': 'Write something...',
      your_name: 'Your name',
    },
    titles: {
      comments: 'Comments',
      'edit-button': 'Edit this comment',
      'cancel-button': 'Cancel edition',
      'delete-button': 'Delete this comment',
      'show-comment': 'Show this comment',
      refresh: 'Refresh comment list',
    },
    messages: {},
  },
  'dark-skin': {
    'general-information': 'General information',
    'social-networks': 'Social networks',
    'share-on': 'Share on:',
    'embed-the-video': 'Embed the video',
    'start-automatically': 'Start automatically',
    'player-color': 'Player color',
    'start-at': 'Start at',
    embed: 'Embed',
    'less-parameters': 'Less parameters',
    'more-parameters': 'More parameters',
    'less-description': 'Show less',
    'more-description': 'Show more',
    'attached-files': 'Attachments',
    chapters: 'Chapters',
    'download-all': 'Download all',
    'author-sheet': 'Author sheet',
    links: 'Links',
    copy: 'Copy',
    '': '',
    // "": "",
    'email-modal': {
      title: 'Send an email',
      'send-to': 'Send to',
      from: 'From',
      subject: 'Subject',
      message: 'Message',
      sending: 'Sending ...',
      send: 'Send',
      // "": "",
      messages: {
        'invalid-email': 'Invalid Email!',
        'field-required': 'This field is required!',
        'thank-you': 'Thank you!',
        'message-sent': 'Your message has been sent',
        'back-to-video': 'Back to site',
        oops: 'Oops!',
        'error-occurred': 'An error occurred while sending the message',
        'try-again': 'try again',
        // "": "",
      },
    },
      'contact-form':{
          title:'To discover our software, give us your contact details and we will get back to you.',
          name:'Name ',
          lastName:'Last name',
          email:'E-mail ',
          tel:'Telephone',
          soc:'Society',
          'function':'Function',
          text:'Text',
          link:'Visit our site',
          submit:'Send',
          messages: {
              'invalid-email': 'Invalid Email!',
              'field-required': 'This field is required!',
              'thank-you': 'Thank you!',
              'message-sent': 'Your message has been sent',
              'back-to-video': 'Back to site',
              oops: 'Oops!',
              'error-occurred': 'An error occurred while sending the message',
              'try-again': 'try again',
              // "": "",
          },
          contact:"Thank you for contacting us.",
          description:"Our team will get back to you quickly."

      }
  },
    captions:{
     "save": "Save",
     "export": "Export",

    }
};



// WEBPACK FOOTER //
// ./src/i18n/en_US.js